import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import { ThunkDispatch } from 'redux-thunk'
import { connect } from 'react-redux'
import { Link } from "react-router-dom";
import {RouteComponentProps, withRouter} from "react-router-dom";

// Thris party.

// Components.
import OrderFlow from '../../components/shared/OrderFlow';
import { filter } from 'lodash';
import { Overlay } from 'molo-shared';
import { QuantityGrid } from 'molo-shared';
import { IgroupedItems as SharedGroupedItems } from 'molo-shared/lib/models/MoloItem';
import { StyleBean as SharedStyleBean } from 'molo-shared/lib/models/Beans';
// import MobileQuantity from '../layout/MobileQuantity';

// Models.
import { StyleBean } from '../../models/Beans';
import Order from '../../models/Order';
import { basketLine } from '../../models/Basket';
import { DeliveryWindow } from '../../models/Style'

import { createStyle, isColorBlocked } from 'molo-shared/lib/models/Style';

// Utils.
import { mapMoloItems, MoloItem, IgroupedItems, IMoloItem } from '../../models/MoloItem';
import { sortBy, uniqBy } from 'lodash';
import { FaExclamation, FaExternalLinkAlt, FaHeart, FaRegHeart } from 'react-icons/fa';
import queryString from 'query-string'
import { roundAmount, getWHPWithDiscount } from '../../utils/priceHelper';
import { triggerWishlistFlyAnimation } from '../../utils/wishlistFlyAnimation';
import { BrandedRevealImage } from 'molo-shared/lib/components/BrandedRevealImage';
import { ProductGalleryThumbStrip } from 'molo-shared/lib/components/ProductGalleryThumbStrip';
import ProductVariantStrip from './ProductVariantStrip';
import {
    buildPackImageUrlFromNiceUrl,
    buildProductImageUrl,
} from '../../utils/productImageUrl';
import { packImagesForProduct } from '../../utils/packImagesForProduct';
import { SeasonImageMap } from '../../store/products/packsIndexNormalize';
import { getDisplaySizeName } from '../../utils/displaySizeName';

// Images.
import OekotexImage from '../../images/sustainability/oekotex.png'
import GotsImage from '../../images/sustainability/gots.png'
import RecycleImage from '../../images/sustainability/recycled.png';
import OrganicImage from '../../images/sustainability/organic.png';
import EcoveroImage from '../../images/sustainability/ecovero.png';
import OcsBlendedImage from '../../images/sustainability/ocsblended.png';

import OCSnoImage from 'molo-shared/lib/images/sustainability/ocs.png';
import GRSnoImage from 'molo-shared/lib/images/sustainability/grs.png';
import GRSMixedImage from 'molo-shared/lib/images/sustainability/grsmixed.png';
import GRSNylonImage from 'molo-shared/lib/images/sustainability/grsnylon.png';

// Store.
import { IProductState } from '../../store/products/reducers';
import { IOrderState } from '../../store/order/orderStore';
import { RootState } from '../../store';
import { getMoloItem } from '../../store/products/actions';
import ProductApi from '../../store/products/ProductApi';
import { IUserSate } from '../../store/user/reducers';
import { IWishlistState } from '../../store/wishlist/reducers';
import { fetchWishlistItems, toggleWishlistItem } from '../../store/wishlist/actions';
import { wishlistItemKey } from '../../store/wishlist/wishlistKey';
import {
    Tooltip,
    Position
} from "@blueprintjs/core";
import OrderApi from '../../store/order/OrderApi';
import { orderTypesInclude } from '../../utils/orderTypeMatch';
import { register } from '../../serviceWorker';

function readItemOrderTypeName(entry: { orderType?: string; OrderType?: string } | null | undefined): string | undefined {
    if (!entry) {
        return undefined;
    }
    return entry.orderType || entry.OrderType;
}

/** DevTools console: filter "b2b orderType match" */
function logOrderTypeMatch(event: string, detail: Record<string, unknown>) {
    console.log('[b2b orderType match]', event, detail);
}

const PRODUCT_OVERLAY_MAXIMIZED_KEY = 'b2b-product-overlay-maximized';
/** Ignore sub-pixel / rounding overflow below this height (px). */
const GRID_OVERFLOW_SLACK_PX = 8;

function readProductOverlayMaximized(): boolean {
    try {
        const v = localStorage.getItem(PRODUCT_OVERLAY_MAXIMIZED_KEY);
        if (v === null) {
            return true;
        }
        return v === 'true';
    } catch (e) {
        return true;
    }
}

function persistProductOverlayMaximized(maximized: boolean) {
    try {
        localStorage.setItem(PRODUCT_OVERLAY_MAXIMIZED_KEY, maximized ? 'true' : 'false');
    } catch (e) {
        // ignore quota / private mode
    }
}

interface ISize {
    code: string,
    name: string,
}

interface imageMapInterface {
    /** Assets pack `niceUrl` path, e.g. `/S22/1S22A206_8483.jpg` */
    imageurl: string;
    imageCode?: string;
    sortOrder?: number;
}
interface IPrice {
    whp: number
    msrp: number
}

interface IPrices {
    [id: string] : IPrice[]
}

interface State {
    moloItems: IgroupedItems,
    sizes: ISize[],
    changes: basketLine,
    itemsLoading: boolean
    imageDoneLoading: boolean
    /** GET style compact index in flight */
    imageMapLoading: boolean
    /** Main preview image (large) not yet decoded */
    mainImageLoading: boolean
    /** Per-thumbnail index once thumb JPG has loaded */
    thumbLoaded: { [index: number]: boolean }
    /** Bumped after each pack image map fetch so <img> remounts and onLoad runs (cache / unchanged URL). */
    imageLayoutNonce: number
    currentStep: string
    infoOpen: boolean,
    imageMap: imageMapInterface[],
    imageMapCurrentIndex: number,
    currencyCode: string,
    isOverflowed: boolean,
    imageIsExpanded: boolean,
    moloMaster: StyleBean | null,
    orderType?: string | undefined
    prices: IPrices
    orderTypes: any[]
    initialLoadDone: boolean
    toolbarHostReady: boolean
    /** Active color variant inside overlay (avoids parent reload on thumb click). */
    viewVariantKey: string
    /** WHP/MSRP for the currently focused grid cell (differential pricing). */
    activeCellPrice: { whp: number; msrp: number; variantKey: string } | null
    /** True when quantity grid frame has vertical overflow (edge case). */
    gridHasOverflow: boolean
    gridScrollAtTop: boolean
    gridScrollAtBottom: boolean
    isMaximized: boolean
}
  
interface OwnProps {
    product: StyleBean
    hide: Function
    showModal: boolean
    order?: Order
    changes?: basketLine
    deliveryWindows?: DeliveryWindow[]
    applyBasketChanges: Function
    applyChanges: (changes?: basketLine) => void
    changeProduct: Function
    lazyLoadMaster?: boolean
    match?: {params: {collection: string, orderType: string}}
    orderType?: string
    checkOrderType?: boolean
    /** Wishlist: use GetAllItemOrderTypes (Model.AllOrderTypesForMasterColor). Default: GetItemOrderTypes. */
    useAllOrderTypesForMasterColor?: boolean
    /** Optional override; normally order types come from GetItemOrderTypes when checkOrderType is set. */
    validOrderTypes?: string[]
}
  
interface DispatchProps {
    getMoloItem: (masterId: string, currencyCode: string, pricegroup: string) => void
    toggleWishlistItem: (
        masterId: string,
        colorCode: string,
        isCurrentlyOnList: boolean
    ) => Promise<void>
    fetchWishlistItems: () => void
}
  
interface StateProps {
    productState: IProductState
    orderState: IOrderState
    userState: IUserSate
    wishlist: IWishlistState
}
  
type Props = StateProps & OwnProps & DispatchProps & RouteComponentProps;

export class ProductOverlay extends Component<Props, State> {

    private mainImgRef = React.createRef<HTMLImageElement>();
    private thumbnailsWrapRef = React.createRef<HTMLDivElement>();
    private toolbarPortalRef = React.createRef<HTMLDivElement>();
    private quantityGridRef = React.createRef<QuantityGrid>();
    private gridFrameRef = React.createRef<HTMLDivElement>();
    private cardRef = React.createRef<HTMLDivElement>();
    private gridFocusBeforeVariantPick: HTMLInputElement | null = null;
    private styleImageMapCache: { key: string; map: SeasonImageMap } | null = null;
    private loadToken = 0;
    private gridResizeObserver: ResizeObserver | null = null;
    private cardResizeObserver: ResizeObserver | null = null;
    private gridNudgeDone = false;
    private gridScrollNudgeTimeoutId: ReturnType<typeof setTimeout> | null = null;
    private gridScrollNudgeReturnTimeoutId: ReturnType<typeof setTimeout> | null = null;
    private gridScrollAnimationFrameId: number | null = null;

    initialChanges: basketLine = {};
    initialMoloItems: IgroupedItems = {};
    initialSizes: ISize[] = [];
    
    state: State = {
        moloItems: this.initialMoloItems,
        sizes: this.initialSizes,
        changes: this.initialChanges,
        itemsLoading: false,
        imageDoneLoading: false,
        imageMapLoading: false,
        mainImageLoading: false,
        thumbLoaded: {},
        imageLayoutNonce: 0,
        currentStep: 'product',
        infoOpen: false,
        imageMap: [],
        imageMapCurrentIndex: 0,
        currencyCode: 'EUR',
        isOverflowed: false,
        imageIsExpanded: false,
        moloMaster: null,
        prices: {},
        orderTypes: [],
        initialLoadDone: false,
        toolbarHostReady: false,
        viewVariantKey: '',
        activeCellPrice: null,
        gridHasOverflow: false,
        gridScrollAtTop: true,
        gridScrollAtBottom: true,
        isMaximized: readProductOverlayMaximized(),
    };

    private setToolbarHostRef = (el: HTMLDivElement | null) => {
        (this.toolbarPortalRef as React.MutableRefObject<HTMLDivElement | null>).current = el;
        if (el && !this.state.toolbarHostReady) {
            this.setState({ toolbarHostReady: true });
        }
    };

    applyMoloItemsFromStore = () => {
        const storeItems = this.props.productState.moloItems;
        const { masterId } = this.props.product;
        if (!storeItems || !storeItems.length) {
            return;
        }

        const items: MoloItem[] = filter(mapMoloItems(storeItems), (item) => {
            return !isColorBlocked(item) && item.masterId === masterId;
            });

            let grouped: IgroupedItems = {};
            const prices: IPrices = {};

            for (const item of items) {
            const key: string = String(item.masterId + item.colorCode);

                if (!grouped[key]) {
                    grouped[key] = [];
                }

                grouped[key].push(item);
            }

            let groupedSorted: IgroupedItems = {};

            for (const groupKey in grouped) {
                if (!groupedSorted[groupKey]) {
                groupedSorted[groupKey] = grouped[groupKey];
                }
            }

            const sizes: ISize[] = [];
        const firstGroupKey = Object.keys(groupedSorted)[0];

        const showUsSizes = this.props.userState.user && this.props.userState.user.showUsSizes === true;

        if (firstGroupKey && groupedSorted[firstGroupKey]) {
            for (const item of groupedSorted[firstGroupKey]) {
                sizes.push({
                    code: item.sizeCode,
                    name: getDisplaySizeName(item, showUsSizes),
                });
            }
            }

            for (const key in groupedSorted) {
            const groupItems = groupedSorted[key];
            const diffPrices: IPrice[] = uniqBy(groupItems.map((item: any) => {
                    return {
                        whp: item.whp,
                        msrp: item.msrp
                    }
                }), 'whp')

                prices[key] = diffPrices;
            }
            
            this.setState({
                moloItems: groupedSorted,
                sizes: sizes,
                itemsLoading: false,
                prices
            });
    };

    loadOverlayData = async () => {
        const token = ++this.loadToken;
        const { product } = this.props;
        const currencyCode = this.props.userState.user ? this.props.userState.user.currencyCode : 'EUR';
        const pricegroup = this.props.userState.user ? this.props.userState.user.customerData.pricegroup : 'ALL';

        let orderType = product.orderType;

        this.setState({
            currencyCode,
            orderType,
            initialLoadDone: false,
            moloItems: this.initialMoloItems,
            sizes: this.initialSizes,
            moloMaster: null,
            imageMap: [],
            imageMapCurrentIndex: 0,
            changes: {},
            viewVariantKey: product.masterId + product.colorCode,
        });

        const imageMapPromise = this.getImageMap();

        const moloItemPromise = this.props.getMoloItem(product.masterId, currencyCode, pricegroup);

        if (this.props.lazyLoadMaster) {
            const moloMaster = await ProductApi.getMaster(product.masterId, product.colorCode, currencyCode, pricegroup)
            if (token !== this.loadToken) {
                return;
            }
            orderType = moloMaster.data.orderType;
            this.setState({ moloMaster: StyleBean.build(createStyle(moloMaster.data), 'style'), orderType })
        }

        if (this.props.checkOrderType) {
            const fetchOrderTypes = this.props.useAllOrderTypesForMasterColor
                ? OrderApi.getAllItemOrderTypes
                : OrderApi.getItemOrderTypes;
            const orderTypesSource = this.props.useAllOrderTypesForMasterColor
                ? 'GetAllItemOrderTypes'
                : 'GetItemOrderTypes';
            const response = await fetchOrderTypes(product.masterId, product.colorCode);
            if (token !== this.loadToken) {
                return;
            }
            const orderTypes = this.filterItemOrderTypesForUser(response.data);
            const allowedNames = this.orderTypeNamesFromEntries(orderTypes);
            const activeType =
                this.props.orderState.order && this.props.orderState.order.orderheader
                    ? this.props.orderState.order.orderheader.orderType
                    : undefined;
            const matchesActive = orderTypesInclude(allowedNames, activeType);
            if (matchesActive) {
                orderType = activeType;
            }
            logOrderTypeMatch(orderTypesSource + ' loaded', {
                masterId: product.masterId,
                colorCode: product.colorCode,
                allowedOrderTypes: allowedNames,
                activeOrderType: activeType != null ? activeType : null,
                orderIsFinal:
                    this.props.orderState.order && this.props.orderState.order.orderheader
                        ? this.props.orderState.order.orderheader.orderIsFinal
                        : null,
                matchesActiveOrder: matchesActive,
                overlayOrderType: orderType != null ? orderType : null,
                rawEntryCount: Array.isArray(response.data) ? response.data.length : 0,
                afterDisallowedFilterCount: orderTypes.length,
            });
            this.setState({ orderTypes, orderType });
        }

        await Promise.all([imageMapPromise, moloItemPromise]);
        if (token !== this.loadToken) {
            return;
        }

        this.applyMoloItemsFromStore();
        this.setState({ initialLoadDone: true }, () => {
            if (!this.props.checkOrderType) {
                return;
            }
            const order = this.props.orderState.order;
            const orderFinal =
                order && order.orderheader ? order.orderheader.orderIsFinal : null;
            logOrderTypeMatch('overlay ready', {
                showOrderGrid: this.hasOrderType() && !!order && !orderFinal,
                allowedOrderTypes: this.getAllowedOrderTypeNames(),
                activeOrderType:
                    order && order.orderheader ? order.orderheader.orderType : null,
                orderIsFinal: orderFinal,
            });
        });
    };

    async componentDidMount() {
        if (!this.props.showModal) {
            return;
        }

        this.props.fetchWishlistItems();
        await this.loadOverlayData();
        this.setupGridOverflowObserver();
        this.scheduleGridLayoutMeasure();
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        const modalOpened = !prevProps.showModal && this.props.showModal;
        const productChanged =
            prevProps.product.colorCode !== this.props.product.colorCode ||
            prevProps.product.masterId !== this.props.product.masterId ||
            prevProps.product.seasonCode !== this.props.product.seasonCode;

        if (modalOpened) {
            this.props.fetchWishlistItems();
            const isMaximized = readProductOverlayMaximized();
            this.setState({ isMaximized });
            this.loadOverlayData();
        } else if (this.props.showModal && productChanged) {
            this.loadOverlayData();
        }

        if (prevProps.productState.moloItems !== this.props.productState.moloItems) {
            this.applyMoloItemsFromStore();
        }

        const prevShowUsSizes = prevProps.userState.user && prevProps.userState.user.showUsSizes;
        const nextShowUsSizes = this.props.userState.user && this.props.userState.user.showUsSizes;
        if (prevShowUsSizes !== nextShowUsSizes && Object.keys(this.state.moloItems).length > 0) {
            this.applyMoloItemsFromStore();
        }

        const thumbStripChanged =
            this.state.imageMap.length !== prevState.imageMap.length ||
            this.state.imageLayoutNonce !== prevState.imageLayoutNonce;
        if (this.state.mainImageLoading || thumbStripChanged) {
            requestAnimationFrame(() => {
                this.flushMainImageIfDecoded();
                this.flushCachedThumbLoads();
            });
        }

        const gridDataChanged =
            prevState.initialLoadDone !== this.state.initialLoadDone ||
            prevState.imageDoneLoading !== this.state.imageDoneLoading ||
            prevState.sizes !== this.state.sizes ||
            prevState.moloItems !== this.state.moloItems;

        if (gridDataChanged || modalOpened) {
            this.setupGridOverflowObserver();
            this.scheduleGridLayoutMeasure();
        }

        if (
            prevState.isMaximized !== this.state.isMaximized
        ) {
            this.scheduleGridLayoutMeasure();
        }

        this.syncWishlistOrderTypeWithActiveOrder(prevProps);
    }

    filterItemOrderTypesForUser = (entries: unknown): Array<{ orderType?: string; OrderType?: string; type?: string }> => {
        if (!Array.isArray(entries)) {
            return [];
        }
        const disallowed =
            this.props.userState.user && this.props.userState.user.disallowedTypes
                ? this.props.userState.user.disallowedTypes
                : [];
        if (!disallowed.length) {
            return entries;
        }
        return entries.filter((entry) => {
            if (!entry || typeof entry !== 'object') {
                return false;
            }
            const typeRaw = (entry as { type?: string }).type;
            const category = typeRaw != null ? String(typeRaw).toLowerCase() : '';
            return disallowed.indexOf(category) === -1;
        });
    };

    orderTypeNamesFromEntries = (
        entries: Array<{ orderType?: string; OrderType?: string }> | undefined | null
    ): string[] => {
        if (!entries || !entries.length) {
            return [];
        }
        return entries
            .map((t) => readItemOrderTypeName(t))
            .filter((name): name is string => !!name);
    };

    getAllowedOrderTypeNames = (): string[] => {
        if (this.props.validOrderTypes && this.props.validOrderTypes.length) {
            return this.props.validOrderTypes;
        }
        return this.orderTypeNamesFromEntries(this.state.orderTypes);
    };

    /** Wishlist/shop: align overlay order context when user switches active order. */
    syncWishlistOrderTypeWithActiveOrder = (prevProps: Props) => {
        if (!this.props.showModal || !this.props.checkOrderType) {
            return;
        }

        const allowedNames = this.getAllowedOrderTypeNames();
        if (!allowedNames.length) {
            return;
        }

        const prevActive =
            prevProps.orderState.order && prevProps.orderState.order.orderheader
                ? prevProps.orderState.order.orderheader.orderType
                : undefined;
        const nextActive =
            this.props.orderState.order && this.props.orderState.order.orderheader
                ? this.props.orderState.order.orderheader.orderType
                : undefined;

        if (prevActive === nextActive && prevProps.orderState.order === this.props.orderState.order) {
            return;
        }

        const matches = orderTypesInclude(allowedNames, nextActive);
        logOrderTypeMatch('active order changed', {
            previousOrderType: prevActive != null ? prevActive : null,
            activeOrderType: nextActive != null ? nextActive : null,
            allowedOrderTypes: allowedNames,
            matchesActiveOrder: matches,
        });

        if (!matches) {
            return;
        }

        if (this.state.orderType === nextActive) {
            return;
        }

        this.setState({ orderType: nextActive });
    };

    componentWillUnmount() {
        this.teardownGridOverflowObserver();
        this.clearGridScrollNudgeTimeouts();
    }

    /** Cachede billeder udløser ikke altid onLoad — tjek complete/naturalWidth. */
    flushMainImageIfDecoded = () => {
        if (!this.state.mainImageLoading) {
            return;
        }
        const el = this.mainImgRef.current;
        if (el && el.complete && el.naturalWidth > 0) {
            this.onMainImageLoad();
        }
    }

    flushCachedThumbLoads = () => {
        const root = this.thumbnailsWrapRef.current;
        if (!root || this.state.imageMap.length < 2) {
            return;
        }
        const imgs = root.querySelectorAll('img.po__left__gallery-thumb__img');
        const next: { [index: number]: boolean } = {};
        imgs.forEach((node) => {
            const img = node as HTMLImageElement;
            const index = Number(img.dataset.thumbIndex);
            if (Number.isNaN(index)) {
                return;
            }
            if (img.complete && img.naturalWidth > 0) {
                next[index] = true;
            }
        });
        if (Object.keys(next).length === 0) {
            return;
        }
        this.setState((prev) => {
            const thumbLoaded = { ...prev.thumbLoaded };
            let changed = false;
            for (const k of Object.keys(next)) {
                const i = Number(k);
                if (!thumbLoaded[i]) {
                    thumbLoaded[i] = true;
                    changed = true;
                }
            }
            return changed ? { thumbLoaded } : null;
        });
    }

    private clearGridScrollNudgeTimeouts = () => {
        if (this.gridScrollNudgeTimeoutId !== null) {
            clearTimeout(this.gridScrollNudgeTimeoutId);
            this.gridScrollNudgeTimeoutId = null;
        }
        if (this.gridScrollNudgeReturnTimeoutId !== null) {
            clearTimeout(this.gridScrollNudgeReturnTimeoutId);
            this.gridScrollNudgeReturnTimeoutId = null;
        }
        if (this.gridScrollAnimationFrameId !== null) {
            cancelAnimationFrame(this.gridScrollAnimationFrameId);
            this.gridScrollAnimationFrameId = null;
        }
    };

    private easeInOutCubic = (t: number) =>
        t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

    private animateGridFrameScroll = (frame: HTMLDivElement, targetTop: number, durationMs: number) => {
        return new Promise<void>((resolve) => {
            const startTop = frame.scrollTop;
            const distance = targetTop - startTop;

            if (Math.abs(distance) < 1) {
                frame.scrollTop = targetTop;
                resolve();
                return;
            }

            const startTime = performance.now();
            const tick = (now: number) => {
                const elapsed = now - startTime;
                const progress = Math.min(1, elapsed / durationMs);
                frame.scrollTop = startTop + distance * this.easeInOutCubic(progress);

                if (progress < 1) {
                    this.gridScrollAnimationFrameId = requestAnimationFrame(tick);
                } else {
                    this.gridScrollAnimationFrameId = null;
                    frame.scrollTop = targetTop;
                    this.updateGridScrollPosition(frame);
                    resolve();
                }
            };

            this.gridScrollAnimationFrameId = requestAnimationFrame(tick);
        });
    };

    private getGridMaxScrollTop = (frame: HTMLDivElement) =>
        Math.max(0, frame.scrollHeight - frame.clientHeight);

    private getGridSelectedScrollTop = (frame: HTMLDivElement): number | null => {
        const activeRow = frame.querySelector('.quantity-grid__row.active-row') as HTMLElement | null;
        if (!activeRow) {
            return null;
        }

        const frameRect = frame.getBoundingClientRect();
        const rowRect = activeRow.getBoundingClientRect();
        const rowTopInFrame = rowRect.top - frameRect.top + frame.scrollTop;
        const target =
            rowTopInFrame - frame.clientHeight / 2 + activeRow.clientHeight / 2;

        return Math.max(0, Math.min(target, this.getGridMaxScrollTop(frame)));
    };

    private clearGridLayoutVars = () => {
        const card = this.cardRef.current;
        if (!card) {
            return;
        }
        card.style.removeProperty('--po-top-row');
        card.style.removeProperty('--po-top-height');
        card.style.removeProperty('--po-grid-max');
        card.classList.remove('po__card--top-expanded', 'po__card--layout-measured');
    };

    private measureGridBlockNaturalHeight = (card: HTMLElement): number => {
        const isMobile = window.matchMedia('(max-width: 900px)').matches;
        if (isMobile) {
            const dock = card.querySelector('.po__order-dock') as HTMLElement | null;
            if (dock) {
                return Math.ceil(dock.scrollHeight);
            }
        }

        const frame = this.gridFrameRef.current;
        if (!frame) {
            return 0;
        }

        let height = frame.scrollHeight;
        const shell = frame.closest('.po__grid-shell');
        if (shell) {
            const action = shell.querySelector('.po__grid-shell__action') as HTMLElement | null;
            if (action) {
                height += action.offsetHeight;
            }
        }

        const section = frame.closest('.po__grid-section') as HTMLElement | null;
        if (section) {
            const sectionStyle = window.getComputedStyle(section);
            height +=
                parseFloat(sectionStyle.paddingTop) + parseFloat(sectionStyle.paddingBottom);
        }

        return Math.ceil(height);
    };

    private measureToolbarHeight = (card: HTMLElement): number => {
        const rail = card.querySelector('.po__order-dock__toolbar-rail') as HTMLElement | null;
        return rail ? Math.ceil(rail.offsetHeight) : 0;
    };

    private applyGridLayoutVars = () => {
        const card = this.cardRef.current;
        const frame = this.gridFrameRef.current;
        if (!card || !frame) {
            return;
        }

        const cardHeight = card.clientHeight;
        if (cardHeight < 1) {
            return;
        }

        const isMobile = window.matchMedia('(max-width: 900px)').matches;
        const gridBlockNatural = this.measureGridBlockNaturalHeight(card);
        const minTopCombined = cardHeight * 0.5;

        if (isMobile) {
            const topHeight = Math.max(minTopCombined, cardHeight - gridBlockNatural);
            const needsGridScroll =
                minTopCombined + gridBlockNatural > cardHeight + GRID_OVERFLOW_SLACK_PX;

            card.style.setProperty('--po-top-height', topHeight + 'px');
            card.style.removeProperty('--po-top-row');

            if (needsGridScroll) {
                card.style.setProperty(
                    '--po-grid-max',
                    Math.max(0, Math.ceil(cardHeight - minTopCombined)) + 'px'
                );
            } else {
                card.style.removeProperty('--po-grid-max');
            }

            card.classList.toggle('po__card--top-expanded', topHeight > minTopCombined + 1);
            card.classList.add('po__card--layout-measured');
            return;
        }

        const toolbarH = this.measureToolbarHeight(card);
        const minRow1 = Math.max(0, minTopCombined - toolbarH);
        const row1Height = Math.max(minRow1, cardHeight - toolbarH - gridBlockNatural);
        const topCombined = row1Height + toolbarH;
        const needsGridScroll =
            topCombined + gridBlockNatural > cardHeight + GRID_OVERFLOW_SLACK_PX;

        card.style.setProperty('--po-top-row', row1Height + 'px');
        card.style.removeProperty('--po-top-height');

        if (needsGridScroll) {
            card.style.setProperty(
                '--po-grid-max',
                Math.max(0, Math.ceil(cardHeight - topCombined)) + 'px'
            );
        } else {
            card.style.removeProperty('--po-grid-max');
        }

        card.classList.toggle('po__card--top-expanded', topCombined > minTopCombined + 1);
        card.classList.add('po__card--layout-measured');
    };

    private disconnectGridLayoutObservers = () => {
        if (this.gridResizeObserver) {
            this.gridResizeObserver.disconnect();
        }
        this.gridResizeObserver = null;
        if (this.cardResizeObserver) {
            this.cardResizeObserver.disconnect();
        }
        this.cardResizeObserver = null;
        window.removeEventListener('resize', this.scheduleGridLayoutMeasure);
    };

    private teardownGridOverflowObserver = () => {
        this.disconnectGridLayoutObservers();
        this.clearGridLayoutVars();
    };

    private setupGridOverflowObserver = () => {
        this.disconnectGridLayoutObservers();
        const frame = this.gridFrameRef.current;
        const card = this.cardRef.current;
        if (!frame) {
            return;
        }

        this.gridResizeObserver = new ResizeObserver(() => {
            this.scheduleGridLayoutMeasure();
        });
        this.gridResizeObserver.observe(frame);

        if (card) {
            this.cardResizeObserver = new ResizeObserver(() => {
                this.scheduleGridLayoutMeasure();
            });
            this.cardResizeObserver.observe(card);
        }

        window.addEventListener('resize', this.scheduleGridLayoutMeasure);
    };

    private updateGridScrollPosition = (frame: HTMLDivElement) => {
        const scrollTop = frame.scrollTop;
        const clientHeight = frame.clientHeight;
        const scrollHeight = frame.scrollHeight;
        const overflowDelta = scrollHeight - clientHeight;
        const hasOverflow = overflowDelta > GRID_OVERFLOW_SLACK_PX;
        const atTop = scrollTop <= GRID_OVERFLOW_SLACK_PX;
        const atBottom =
            !hasOverflow || scrollTop + clientHeight >= scrollHeight - GRID_OVERFLOW_SLACK_PX;

        if (
            atTop !== this.state.gridScrollAtTop ||
            atBottom !== this.state.gridScrollAtBottom
        ) {
            this.setState({
                gridScrollAtTop: atTop,
                gridScrollAtBottom: atBottom,
            });
        }
    };

    measureGridOverflow = () => {
        const frame = this.gridFrameRef.current;
        if (!frame) {
            return;
        }

        const overflowDelta = frame.scrollHeight - frame.clientHeight;
        const hasOverflow = overflowDelta > GRID_OVERFLOW_SLACK_PX;
        const atTop = frame.scrollTop <= GRID_OVERFLOW_SLACK_PX;
        const atBottom =
            !hasOverflow ||
            frame.scrollTop + frame.clientHeight >= frame.scrollHeight - GRID_OVERFLOW_SLACK_PX;

        const overflowChanged = hasOverflow !== this.state.gridHasOverflow;
        const scrollPosChanged =
            atTop !== this.state.gridScrollAtTop ||
            atBottom !== this.state.gridScrollAtBottom;

        if (overflowChanged || scrollPosChanged) {
            this.setState(
                {
                    gridHasOverflow: hasOverflow,
                    gridScrollAtTop: atTop,
                    gridScrollAtBottom: atBottom,
                },
                () => {
                    if (overflowChanged && hasOverflow) {
                        this.playGridScrollNudge();
                    }
                }
            );
        } else if (hasOverflow && !this.gridNudgeDone) {
            this.playGridScrollNudge();
        }
    };

    scheduleGridLayoutMeasure = () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.applyGridLayoutVars();
                this.measureGridOverflow();
            });
        });
    };

    handleGridFrameScroll = () => {
        const frame = this.gridFrameRef.current;
        if (!frame) {
            return;
        }
        this.updateGridScrollPosition(frame);
    };

    private scrollGridSelectionIntoView = (smooth = false) => {
        const frame = this.gridFrameRef.current;
        const grid = this.quantityGridRef.current;
        if (!frame || !grid) {
            return;
        }

        const targetTop = this.getGridSelectedScrollTop(frame);
        if (targetTop === null) {
            grid.scrollActiveRowIntoView();
            return;
        }

        if (!smooth) {
            frame.scrollTop = targetTop;
            this.updateGridScrollPosition(frame);
            grid.scrollActiveRowIntoView();
            return;
        }

        const distance = Math.abs(targetTop - frame.scrollTop);
        const durationMs = Math.min(700, Math.max(400, distance * 0.9));

        void this.animateGridFrameScroll(frame, targetTop, durationMs).then(() => {
            grid.scrollActiveRowIntoView();
            this.measureGridOverflow();
        });
    };

    private scheduleScrollGridSelectionIntoView = (smooth = false) => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.scrollGridSelectionIntoView(smooth);
            });
        });
    };

    private playGridScrollNudge = () => {
        if (this.gridNudgeDone || !this.state.gridHasOverflow) {
            return;
        }

        const frame = this.gridFrameRef.current;
        if (!frame) {
            return;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.gridNudgeDone = true;
            this.scheduleScrollGridSelectionIntoView(false);
            return;
        }

        this.gridNudgeDone = true;
        this.clearGridScrollNudgeTimeouts();

        const maxScroll = this.getGridMaxScrollTop(frame);
        if (maxScroll < 1) {
            this.scheduleScrollGridSelectionIntoView(false);
            return;
        }

        // Hint: start at bottom, ease slowly up to top, then ease to selected row.
        frame.scrollTop = maxScroll;
        this.updateGridScrollPosition(frame);

        const hintDurationMs = Math.min(1600, Math.max(900, maxScroll * 1.4));

        void this.animateGridFrameScroll(frame, 0, hintDurationMs).then(() => {
            this.measureGridOverflow();
            this.scheduleScrollGridSelectionIntoView(true);
        });
    };

    getGridFrameClassName = () => {
        let className = 'po__grid-shell__frame';
        if (this.state.gridHasOverflow) {
            className += ' po__grid-shell__frame--scrollable';
        }
        if (this.state.gridScrollAtTop) {
            className += ' po__grid-shell__frame--at-top';
        }
        if (this.state.gridScrollAtBottom) {
            className += ' po__grid-shell__frame--at-bottom';
        }
        return className;
    };

    private styleImageCacheKey(seasonCode: string, masterId: string): string {
        return `${seasonCode}|${masterId}`.toLowerCase();
    }

    private imageMapFingerprint(map: imageMapInterface[]): string {
        return map.map((entry) => entry.imageurl).join('|');
    }

    resolveMainImageUrl = (
        product: StyleBean,
        imageMap: imageMapInterface[],
        currentIndex: number
    ): string => {
        let imgUrl = buildProductImageUrl(
            product.seasonCode,
            product.masterId,
            product.colorCode,
            'large'
        );

        if (imageMap.length > 0) {
            const imgStr = imageMap[currentIndex].imageurl;
            const fromMap = buildPackImageUrlFromNiceUrl(imgStr, 'large');
            if (fromMap) {
                imgUrl = fromMap;
            }
        }

        return imgUrl;
    }

    preloadImage = (url: string): Promise<void> =>
        new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve();
            img.onerror = () => resolve();
            img.src = url;
        });

    getImageMap = async (): Promise<void> => {
        const { seasonCode, masterId, colorCode } = this.props.product;
        const cacheKey = this.styleImageCacheKey(seasonCode, masterId);
        const prevFingerprint = this.imageMapFingerprint(this.state.imageMap);

        this.setState({
            imageMapLoading: true,
            thumbLoaded: {},
            mainImageLoading: false,
            imageDoneLoading: false,
        });

        let styleMap: SeasonImageMap;
        if (this.styleImageMapCache && this.styleImageMapCache.key === cacheKey) {
            styleMap = this.styleImageMapCache.map;
        } else {
            styleMap = await ProductApi.getStyleImageMap(seasonCode, masterId);
            this.styleImageMapCache = { key: cacheKey, map: styleMap };
        }

        const imageMap = packImagesForProduct(styleMap, { masterId, colorCode });
        const mapChanged = this.imageMapFingerprint(imageMap) !== prevFingerprint;
        const mainImageUrl = this.resolveMainImageUrl(this.props.product, imageMap, 0);

        await this.preloadImage(mainImageUrl);

        return new Promise((resolve) => {
            this.setState(
                (prev) => ({
                    imageMap,
                    imageMapLoading: false,
                    imageMapCurrentIndex: 0,
                    itemsLoading: false,
                    imageLayoutNonce: mapChanged ? prev.imageLayoutNonce + 1 : prev.imageLayoutNonce,
                    mainImageLoading: true,
                }),
                () => {
                    requestAnimationFrame(() => {
                        this.flushMainImageIfDecoded();
                        this.flushCachedThumbLoads();
                    });
                    resolve();
                }
            );
        });
    }

    onThumbnailSelect = (index: number) => {
        if (index === this.state.imageMapCurrentIndex) {
            return;
        }
        this.setState({ imageMapCurrentIndex: index, mainImageLoading: true }, () => {
            requestAnimationFrame(() => this.flushMainImageIfDecoded());
        });
    }

    private getCachedImageMapForItem(item: IMoloItem): imageMapInterface[] {
        if (!this.styleImageMapCache) {
            return [];
        }
        return packImagesForProduct(this.styleImageMapCache.map, {
            masterId: item.masterId,
            colorCode: item.colorCode,
        });
    }

    getGridVariantThumbKeys = (): string[] => Object.keys(this.state.moloItems);

    getViewVariantKey = (): string => {
        const { product } = this.props;
        return this.state.viewVariantKey || (product.masterId + product.colorCode);
    };

    buildDisplayProductFromItem = (item: IMoloItem): StyleBean => {
        const bean = StyleBean.build(item, 'moloItem');
        const base = this.state.moloMaster || this.props.product;
        bean.currencyCode = this.state.currencyCode || base.currencyCode;
        bean.collectionName = base.collectionName;
        bean.navCollection = base.navCollection;
        bean.orderType = this.state.orderType || base.orderType;
        bean.fabricComposition = base.fabricComposition;
        bean.styleComment = base.styleComment;
        bean.b2BMasterComment = base.b2BMasterComment;
        if (item.deliveryWindowLabel) {
            bean.deliveryWindow = {
                label: item.deliveryWindowLabel,
                code: item.deliveryWindow,
            } as DeliveryWindow;
        }
        return bean;
    };

    getDisplayProduct = (): StyleBean => {
        const key = this.getViewVariantKey();
        const propsKey = this.props.product.masterId + this.props.product.colorCode;

        if (key === propsKey && this.props.lazyLoadMaster && this.state.moloMaster) {
            return this.state.moloMaster;
        }

        const row = this.state.moloItems[key];
        if (row && row[0]) {
            return this.buildDisplayProductFromItem(row[0]);
        }

        return this.props.lazyLoadMaster && this.state.moloMaster
            ? this.state.moloMaster
            : this.props.product;
    };

    private captureGridFocus = (): HTMLInputElement | null => {
        const el = document.activeElement;
        if (el instanceof HTMLInputElement && el.closest('#quantity-grid-table')) {
            return el;
        }
        return null;
    };

    onVariantPickerMouseDown = () => {
        this.gridFocusBeforeVariantPick = this.captureGridFocus();
    };

    private getVariantKeyForGridInput = (input: HTMLInputElement): string | null => {
        const row = input.closest('tr');
        const table = document.querySelector('#quantity-grid-table');
        if (!row || !table || !table.contains(row)) {
            return null;
        }
        const rowIndex = (row as HTMLTableRowElement).rowIndex;
        const keys = Object.keys(this.state.moloItems);
        const dataRowIndex = rowIndex - 1;
        if (dataRowIndex < 0 || dataRowIndex >= keys.length) {
            return null;
        }
        return keys[dataRowIndex];
    };

    private isGridFocusedOnVariant = (variantKey: string): boolean => {
        const active = document.activeElement;
        if (!(active instanceof HTMLInputElement)) {
            return false;
        }
        return this.getVariantKeyForGridInput(active) === variantKey;
    };

    private focusGridVariantDom = (variantKey: string): boolean => {
        const table = document.querySelector('#quantity-grid-table') as HTMLTableElement | null;
        if (!table) {
            return false;
        }

        const keys = Object.keys(this.state.moloItems);
        const dataRowIndex = keys.indexOf(variantKey);
        if (dataRowIndex < 0) {
            return false;
        }

        const row = table.rows[dataRowIndex + 1];
        if (!row) {
            return false;
        }

        if (this.isGridFocusedOnVariant(variantKey)) {
            return true;
        }

        const input = row.querySelector('input') as HTMLInputElement | null;
        if (!input) {
            return false;
        }

        input.focus();
        if (typeof input.select === 'function') {
            input.select();
        }
        return true;
    };

    /** After gallery/variant pick: keep cell focus if already on that variant; else focus grid row. */
    private focusGridAfterVariantSelect = (
        targetVariantKey: string,
        priorInput: HTMLInputElement | null,
        attempt: number = 0
    ) => {
        const maxAttempts = 5;
        const run = () => {
            const priorVariantKey = priorInput
                ? this.getVariantKeyForGridInput(priorInput)
                : null;

            if (
                priorInput &&
                priorVariantKey === targetVariantKey &&
                document.body.contains(priorInput)
            ) {
                priorInput.focus();
                if (typeof priorInput.select === 'function') {
                    priorInput.select();
                }
                return;
            }

            const grid = this.quantityGridRef.current;
            if (grid) {
                grid.focusVariantRow(targetVariantKey);
            } else {
                this.focusGridVariantDom(targetVariantKey);
            }

            if (!this.isGridFocusedOnVariant(targetVariantKey) && attempt < maxAttempts) {
                requestAnimationFrame(() => {
                    this.focusGridAfterVariantSelect(targetVariantKey, priorInput, attempt + 1);
                });
            }
        };

        if (attempt === 0) {
            requestAnimationFrame(run);
        } else {
            run();
        }
    };

    private beginVariantImageLoad = (
        variantKey: string,
        mainImageUrl: string,
        safePackIndex: number
    ) => {
        void this.preloadImage(mainImageUrl).then(() => {
            if (
                this.getViewVariantKey() !== variantKey ||
                this.state.imageMapCurrentIndex !== safePackIndex
            ) {
                return;
            }
            this.setState({ mainImageLoading: false, imageDoneLoading: true }, () => {
                requestAnimationFrame(() => this.flushMainImageIfDecoded());
            });
        });
    };

    switchToVariant = (variantKey: string, packIndex: number = 0) => {
        const gridInput = this.gridFocusBeforeVariantPick || this.captureGridFocus();
        this.gridFocusBeforeVariantPick = null;

        if (
            variantKey === this.getViewVariantKey() &&
            packIndex === this.state.imageMapCurrentIndex
        ) {
            this.focusGridAfterVariantSelect(variantKey, gridInput);
            return;
        }
        const row = this.state.moloItems[variantKey];
        if (!row || !row[0]) {
            return;
        }
        const item = row[0];
        const imageMap = this.getCachedImageMapForItem(item);
        const displayProduct = this.buildDisplayProductFromItem(item);
        const safePackIndex =
            imageMap.length > 0
                ? Math.min(Math.max(0, packIndex), imageMap.length - 1)
                : 0;
        const mainImageUrl = this.resolveMainImageUrl(displayProduct, imageMap, safePackIndex);

        if (variantKey === this.getViewVariantKey()) {
            this.setState(
                {
                    imageMapCurrentIndex: safePackIndex,
                    imageIsExpanded: false,
                    mainImageLoading: true,
                },
                () => {
                    this.focusGridAfterVariantSelect(variantKey, gridInput);
                    this.beginVariantImageLoad(variantKey, mainImageUrl, safePackIndex);
                }
            );
            return;
        }

        this.setState(
            {
                viewVariantKey: variantKey,
                imageMap,
                imageMapCurrentIndex: safePackIndex,
                imageIsExpanded: false,
                mainImageLoading: true,
                imageLayoutNonce: this.state.imageLayoutNonce + 1,
            },
            () => {
                this.focusGridAfterVariantSelect(variantKey, gridInput);
                this.beginVariantImageLoad(variantKey, mainImageUrl, safePackIndex);
            }
        );
    };

    private getPackThumbUrl(item: IMoloItem, entry: imageMapInterface): string {
        const fromMap = buildPackImageUrlFromNiceUrl(entry.imageurl, 'thumb');
        if (fromMap) {
            return fromMap;
        }
        return buildProductImageUrl(item.seasonCode, item.masterId, item.colorCode, 'thumb');
    }

    getVariantGalleryThumbGroups = () => {
        return this.getGridVariantThumbKeys().map((variantKey) => {
            const item = this.state.moloItems[variantKey][0];
            const imageMap = this.getCachedImageMapForItem(item);

            if (!imageMap.length) {
                return [
                    {
                        src: buildProductImageUrl(
                            item.seasonCode,
                            item.masterId,
                            item.colorCode,
                            'thumb'
                        ),
                        alt: item.colorName,
                    },
                ];
            }

            return imageMap.map((mapEntry) => ({
                src: this.getPackThumbUrl(item, mapEntry),
                alt: item.colorName,
            }));
        });
    };

    getGalleryThumbEntries = () => {
        const entries: Array<{
            variantKey: string;
            packIndex: number;
            src: string;
            alt: string;
        }> = [];

        this.getVariantGalleryThumbGroups().forEach((group, groupIndex) => {
            const variantKey = this.getGridVariantThumbKeys()[groupIndex];
            group.forEach((thumb, packIndex) => {
                entries.push({
                    variantKey,
                    packIndex,
                    src: thumb.src,
                    alt: thumb.alt || '',
                });
            });
        });

        return entries;
    };

    getCurrentGalleryThumbIndex = (): number => {
        const variantKey = this.getViewVariantKey();
        const packIndex = this.state.imageMapCurrentIndex;
        const index = this.getGalleryThumbEntries().findIndex(
            (entry) => entry.variantKey === variantKey && entry.packIndex === packIndex
        );
        return index >= 0 ? index : 0;
    };

    onGalleryThumbSelect = (index: number) => {
        const entry = this.getGalleryThumbEntries()[index];
        if (!entry) {
            return;
        }
        this.switchToVariant(entry.variantKey, entry.packIndex);
    };

    onThumbImageLoad = (index: number) => {
        this.setState((prev) => ({
            thumbLoaded: { ...prev.thumbLoaded, [index]: true },
        }));
    }

    onThumbImageError = (index: number) => {
        this.onThumbImageLoad(index);
    }

    getEffectiveChanges = (): basketLine => ({
        ...this.state.changes,
        ...(this.props.changes || {}),
    });

    getPendingChangesAgainstBasket = (): basketLine => {
        const changes = this.getEffectiveChanges();
        const basketLines =
            (this.props.orderState.basket && this.props.orderState.basket.basketLines) ||
            {};
        const pending: basketLine = {};

        for (const key in changes) {
            if (!Object.prototype.hasOwnProperty.call(changes, key)) {
                continue;
            }
            const nextQty = +(changes[key] as number) || 0;
            const baseline = +(basketLines[key] || 0);
            if (nextQty !== baseline) {
                pending[key] = nextQty;
            }
        }

        return pending;
    };

    hasPendingChanges = (): boolean => {
        return Object.keys(this.getPendingChangesAgainstBasket()).length > 0;
    };

    handleFooterAction = () => {
        if (this.hasPendingChanges()) {
            this.props.applyChanges(this.getPendingChangesAgainstBasket());
        } else {
            this.onHideModal();
        }
    };

    handleGridActiveCellChange = (payload: {
        variantKey: string;
        sizeIndex: number;
        whp?: number;
        msrp?: number;
    }) => {
        if (payload.whp == null) {
            return;
        }
        this.setState({
            activeCellPrice: {
                whp: payload.whp,
                msrp: payload.msrp != null ? payload.msrp : 0,
                variantKey: payload.variantKey,
            },
        });
    };

    getPriceTierClassName = (price: IPrice, priceList: IPrice[], product: StyleBean): string => {
        const active = this.state.activeCellPrice;
        const productKey = product.masterId + product.colorCode;
        if (
            priceList.length <= 1 ||
            !active ||
            active.variantKey !== productKey
        ) {
            return '';
        }
        return price.whp === active.whp
            ? ' po__order-actions__price-tier--active'
            : ' po__order-actions__price-tier--inactive';
    };

    handleGridActiveVariantChange = (variantKey: string) => {
        if (variantKey === this.getViewVariantKey()) {
            return;
        }
        this.syncViewVariantFromGrid(variantKey, 0);
    };

    /** Gallery sync from grid focus — must not steal keyboard focus from inputs. */
    syncViewVariantFromGrid = (variantKey: string, packIndex: number = 0) => {
        const row = this.state.moloItems[variantKey];
        if (!row || !row[0]) {
            return;
        }
        const item = row[0];
        const imageMap = this.getCachedImageMapForItem(item);
        const safePackIndex =
            imageMap.length > 0
                ? Math.min(Math.max(0, packIndex), imageMap.length - 1)
                : 0;
        const displayProduct = this.buildDisplayProductFromItem(item);
        const mainImageUrl = this.resolveMainImageUrl(displayProduct, imageMap, safePackIndex);

        this.setState({
            viewVariantKey: variantKey,
            imageMap,
            imageMapCurrentIndex: safePackIndex,
            imageIsExpanded: false,
            mainImageLoading: true,
        });

        this.preloadImage(mainImageUrl).then(() => {
            if (this.getViewVariantKey() !== variantKey) {
                return;
            }
            this.setState({ mainImageLoading: false, imageDoneLoading: true });
            requestAnimationFrame(() => this.flushMainImageIfDecoded());
        });
    };

    renderOrderGrid = () => (
        <div className="po__grid">
                <QuantityGrid
                ref={this.quantityGridRef}
                basket={this.props.orderState.basket}
                changes={this.getEffectiveChanges()}
                sizes={this.state.sizes}
                    orderState={this.props.orderState}
                moloItems={this.state.moloItems as SharedGroupedItems}
                selectedProduct={this.getDisplayProduct() as SharedStyleBean}
                updateChanges={this.updateChanges}
                    sectionTitle="Add to order"
                getRowImageUrl={(seasonCode, masterId, colorCode) =>
                    buildProductImageUrl(seasonCode, masterId, colorCode, 'thumb')
                }
                layout="overlay"
                hideSectionHeader={true}
                toolbarPortalTarget={this.toolbarPortalRef}
                showFooterBar={true}
                showFooterConfirm={false}
                onActiveVariantChange={this.handleGridActiveVariantChange}
                onActiveCellChange={this.handleGridActiveCellChange}
                />
            </div>
    )

    updateChanges = (itemIdOrChanges: number | string | basketLine, quantity?: number) => {
        const changes = typeof itemIdOrChanges === 'object'
            ? itemIdOrChanges
            : {[itemIdOrChanges]: +(quantity || 0)};
        this.setState((prev) => ({
            changes: { ...prev.changes, ...changes },
        }));
        this.props.applyBasketChanges(changes);
    }

    isProductOnWishlist = (product: StyleBean) =>
        !!this.props.wishlist.itemKeys[wishlistItemKey(product.masterId, product.colorCode)];

    handleWishlistToggle = async (e: React.MouseEvent<HTMLButtonElement>, product: StyleBean) => {
        e.stopPropagation();
        const isOnWishlist = this.isProductOnWishlist(product);
        const originElement = e.currentTarget as HTMLElement;
        await this.props.toggleWishlistItem(product.masterId, product.colorCode, isOnWishlist);
        if (!isOnWishlist) {
            triggerWishlistFlyAnimation(originElement);
        }
    };

    renderColors = () => {
        const activeKey = this.getViewVariantKey();
        const variantKeys = Object.keys(this.state.moloItems).filter(
            (itemKey) => itemKey !== activeKey
        );

        if (!variantKeys.length) {
                                return null;
                            }

        const variantCards = variantKeys.map((itemKey) => {
            const item = this.state.moloItems[itemKey][0];
            const isSoldOut = !this.state.moloItems[itemKey].filter(
                (rowItem) => rowItem.available > 0
            ).length;

            return {
                key: itemKey,
                deliveryWindowLabel: item.deliveryWindowLabel,
                colorName: item.colorName,
                imgUrl: buildProductImageUrl(
                    item.seasonCode,
                    item.masterId,
                    item.colorCode,
                    'thumb'
                ),
                isSoldOut,
                isActive: itemKey === activeKey,
            };
        });
                            
                            return (
            <div className="po__variants po__variants--carousel">
                <div className="po__variants__divider" aria-hidden="true" />
                <ProductVariantStrip
                    variants={variantCards}
                    onSelect={this.switchToVariant}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        this.onVariantPickerMouseDown();
                    }}
                />
            </div>
        );
    };

    renderPrices = (product: StyleBean) => {
        const priceList = this.state.prices[product.masterId + product.colorCode];
        if (!priceList || !priceList.length) {
            return null;
        }

        const discount = +this.props.userState.user.customerData.linediscount;

        return (
            <div className="po__order-actions__price">
                <div className="po__order-actions__price-whp">
                    {priceList.map((price: IPrice, key: number) => (
                        <React.Fragment key={key}>
                            <span className={'po__order-actions__price-tier' + this.getPriceTierClassName(price, priceList, product)}>
                                {roundAmount(getWHPWithDiscount(price.whp, discount))}
                            </span>
                            {key + 1 !== priceList.length && (
                                <span className="po__order-actions__price-sep"> - </span>
                            )}
                        </React.Fragment>
                    ))}
                    {' ' + this.state.currencyCode}
                                    </div>
                <div className="po__order-actions__price-msrp">
                    RRP:{' '}
                    {priceList.map((price: IPrice, key: number) => (
                        <React.Fragment key={key}>
                            <span className={'po__order-actions__price-tier' + this.getPriceTierClassName(price, priceList, product)}>
                                {roundAmount(price.msrp)}
                            </span>
                            {key + 1 !== priceList.length && (
                                <span className="po__order-actions__price-sep"> - </span>
                            )}
                        </React.Fragment>
                    ))}
                    {' ' + this.state.currencyCode}
                                </div>
                </div>
        );
    };

    renderProductDescription = (product: StyleBean) => {
        const parts: string[] = [];
        if (product.fabricComposition) {
            parts.push(product.fabricComposition);
        }
        if (product.styleComment) {
            parts.push(product.styleComment.replace(/<[^>]+>/g, ' ').trim());
        }

        if (!parts.length) {
            return null;
        }

        return <p className="po__header__description">{parts.join(' ')}</p>;
    };

    shouldShowOrderToolbar = () =>
        !!(
            this.props.orderState.order &&
            this.hasOrderType() &&
            !this.props.orderState.order.orderheader.orderIsFinal
        );

    renderOrderToolbarHost = () => {
        if (!this.shouldShowOrderToolbar()) {
            return null;
        }

        return <div className="po__order-toolbar" ref={this.setToolbarHostRef} />;
    };

    renderSizes = (selectedMoloItem: IMoloItem[]) => (
        <div className="po__sizes">
            {
                this.state.sizes.map((size, key) => (
                    <div key={key} className="po__sizes__size">{ size.name }</div>
                ))
            }
        </div>
    );

    renderHeader = (product: StyleBean) => (
        <div className="po__header po__header--modern">
            <div className="po__header__top">
                <div className="po__header__intro">
                    {product.deliveryWindow && (
                        <span className="po__header__label">
                            {product.orderType && product.orderType.toLowerCase() !== 'reorder'
                                ? product.seasonCode + ' / '
                                : ''}
                            {product.deliveryWindow.label}
                        </span>
                    )}
                    <h1 className="po__header__title po__header__heading">
                        <span className="po__header__title-style --highlighted">{product.description} </span>
                <Tooltip
                    content={<div>Click for products in same color</div>}
                    position={Position.RIGHT}
                >
                    <Link
                                className="po__header__title-link po__search-link"
                        to={{
                            pathname: '/search',
                                    search: queryString.stringify({
                                collection: product.collectionName,
                                color: product.colorCode,
                                orderType: product.orderType,
                                masterColor: product.masterColor,
                                masterId: product.masterId,
                                colorCode: product.colorCode,
                                    }),
                        }}
                    >
                                {product.colorName}
                                <span className="po__search-click">
                                    <FaExternalLinkAlt />
                                </span>
                    </Link>
                </Tooltip>
                    </h1>
                    <p className="po__header__meta">
                        <span className="po__header__meta-id">
                            {product.masterId} {product.colorCode}
                        </span>
            </p>
                </div>
            </div>

            {this.renderProductDescription(product)}
            
            {(product.b2BColorComment || product.b2BMasterComment) && (
                <div className="po__header__note">
                    <span className="--icon"><FaExclamation /></span>
                    <p>{product.b2BMasterComment}</p>
                    <p>{product.b2BColorComment}</p>
                </div>
            )}
            {product.discontinued && (
                <div className="po__header__note">
                    <span className="--icon"><FaExclamation /></span>
                    <p><b>This product is discontinued</b></p>
                </div>
            )}
        </div>
    );

    onKeyPressed = (e: any) => {
        if (e.key === 'Enter') {
            this.handleFooterAction();
        }
    }

    onMainImageLoad = () => {
        this.setState({ mainImageLoading: false, imageDoneLoading: true });
    }

    onMainImageError = () => {
        this.setState({ mainImageLoading: false, imageDoneLoading: true });
    }

    onHandleOpenOrderFlow = () => {
        this.setState({ currentStep: 'orderFlow' })
    }

    renderOrderFlow = () => {
        return (
            <OrderFlow
                orderFlowDone={() => this.setState({ currentStep: 'product' })}
                orderType={this.state.orderType || this.props.orderType}
                multiOrderTypes={this.state.orderTypes}
                allowedOrderTypes={this.getAllowedOrderTypeNames()}
            />
        )
    }

    activeOrderMatchesProductContext = (): boolean => {
        const order = this.props.orderState.order;
        if (!order || !order.orderheader || order.orderheader.orderIsFinal) {
            return false;
        }

        const activeType = order.orderheader.orderType;

        if (orderTypesInclude(this.getAllowedOrderTypeNames(), activeType)) {
            return true;
        }

        const productType = this.state.orderType;
        const routeType = this.props.orderType;

        if (productType && activeType === productType) {
            return true;
        }
        if (routeType && activeType === routeType) {
            return true;
        }

        if (
            order.isCurrentOrderType &&
            productType &&
            activeType === productType
        ) {
            return true;
        }

        return false;
    };

    hasOrderType = () => this.activeOrderMatchesProductContext();

    getOrderType = () => {
        const order = this.props.orderState.order;
        if (order && order.orderheader && this.activeOrderMatchesProductContext()) {
            return order.orderheader.orderType;
        }

        return this.state.orderType || this.props.orderType || 'REORDER';
    }

    renderSkeletonLayout = () => (
        <div className="po po--loading">
            <div className="po__content">
                <div className="po__left">
                    <div className="po__left__image-wrap po-overlay-skeleton__image" aria-hidden="true" />
                    <div className="po__left__thumbnails-slot" aria-hidden="true" />
                </div>
                <div className="po__right po-overlay-skeleton__right">
                    <div className="po-overlay-skeleton__line po-overlay-skeleton__line--short" />
                    <div className="po-overlay-skeleton__line" />
                    <div className="po-overlay-skeleton__line po-overlay-skeleton__line--medium" />
                </div>
            </div>
        </div>
    );

    renderModalContent = () => {
        if (!this.state.initialLoadDone) {
            return this.renderSkeletonLayout();
        }

        const product = this.getDisplayProduct();
        const selectedMoloItem = this.state.moloItems[this.getViewVariantKey()];
        const imgUrl = this.resolveMainImageUrl(
            product,
            this.state.imageMap,
            this.state.imageMapCurrentIndex
        );

        if (this.state.currentStep === 'orderFlow') {
            return this.renderOrderFlow()
        }

        const showGrid = !!(
            this.props.orderState.order &&
            this.hasOrderType() &&
            !this.props.orderState.order.orderheader.orderIsFinal &&
            this.state.imageDoneLoading
        );

        const poClassName =
            'po po--modern' +
            (!this.state.imageMapLoading ? ' po--gallery-ready' : '') +
            (showGrid ? ' po--with-grid' : '');

        return (
            <div className={poClassName} onKeyDown={this.onKeyPressed} style={{ position: 'relative' }}>
                {this.state.imageIsExpanded && this.imageOverlay(imgUrl)}
                <div
                    ref={this.cardRef}
                    className={
                        'po__card' +
                        (showGrid ? ' po__card--with-grid' : '') +
                        (showGrid && this.state.gridHasOverflow ? ' po__card--grid-scrollable' : '')
                    }
                >
                    <section
                        className={
                            'po__product-section' + (showGrid ? ' po__product-section--with-grid' : '')
                        }
                    >
                <div className="po__content">
                    <div className="po__left">
                        <div className="po__left__image-wrap">
                            <button
                                type="button"
                                className={
                                    'po__left__wishlist' +
                                    (this.isProductOnWishlist(product) ? ' po__left__wishlist--on' : '')
                                }
                                disabled={
                                    this.props.wishlist.loading ||
                                    this.props.wishlist.mutatingKey ===
                                        wishlistItemKey(product.masterId, product.colorCode)
                                }
                                onClick={(e) => this.handleWishlistToggle(e, product)}
                                aria-label={
                                    this.isProductOnWishlist(product)
                                        ? 'Remove from wishlist'
                                        : 'Add to wishlist'
                                }
                            >
                                {this.isProductOnWishlist(product) ? <FaHeart /> : <FaRegHeart />}
                            </button>
                            <BrandedRevealImage
                                ref={this.mainImgRef}
                                key={imgUrl}
                                variant="overlay-main"
                                src={imgUrl}
                                alt="large product"
                                imageClassName={
                                    'po__left__image' +
                                    (this.state.imageIsExpanded ? ' expanded' : '')
                                }
                                onClick={() =>
                                    this.setState({ imageIsExpanded: !this.state.imageIsExpanded })
                                }
                                onLoad={this.onMainImageLoad}
                                onError={this.onMainImageError}
                            />
                        {
                            product.oekotex && product.oekotex !== '' &&
                            <div className="po__left__sustainablity --oekotex">
                                <img src={OekotexImage} alt="OekotexImage" />
                                <svg viewBox="0 0 240 80" xmlns="http://www.w3.org/2000/svg" className="sustainability__code">
                                    <text x="20" y="35" className="small">{product.oekotex}</text>
                                </svg>
                            </div>
                        }
                        {
                            product.gots && product.gots !== '' &&
                            <div className="po__left__sustainablity --gots">
                                <img src={GotsImage} alt="GotsImage" />
                            </div>
                        }
                        {
                            product.ocsno && product.ocsno !== '' &&
                            <div className="po__left__sustainablity --OCSno">
                                <img src={OCSnoImage} alt="GotsImage" />
                            </div>
                        }
                        { 
                            product.ocsblended && product.ocsblended  !== '' &&
                            <div className="po__left__sustainablity --OcsBlended">
                                <img src={OcsBlendedImage} alt="ocsblended image" />
                            </div>
                        }
                        {
                            product.grsno && product.grsno !== '' && product.grsno.startsWith('N:') &&
                            <div className="po__left__sustainablity --grsno">
                                <img src={GRSNylonImage} alt="grs image" />
                            </div>
                        }
                        {
                            product.grsno && product.grsno !== '' && product.grsno.startsWith('M:') &&
                            <div className="po__left__sustainablity --grsno">
                                <img src={GRSMixedImage} alt="grs image" />
                            </div>
                        }
                        {
                            product.grsno && product.grsno !== '' && !product.grsno.startsWith('N:') && !product.grsno.startsWith('M:')  &&
                            <div className="po__left__sustainablity --grsno">
                                <img src={GRSnoImage} alt="grs image" />
                            </div>
                        }
                        {
                            !!product.organic &&
                            <div className="po__left__sustainablity --organic">
                                <img src={OrganicImage} alt="OrganicImage" />
                            </div>
                        }
                        {
                            !!product.ecovero &&
                            <div className="po__left__sustainablity --ecovery">
                                <img src={EcoveroImage} alt="OrganicImage" />
                            </div>
                        }
                        {
                            product.recycled &&
                            <div className="po__left__sustainablity --recycled">
                                <img src={RecycleImage} alt="Recycled" />
                            </div>
                        }
                        </div>
                        <div
                            className="po__left__thumbnails-slot"
                            onMouseDown={this.onVariantPickerMouseDown}
                        >
                            <ProductGalleryThumbStrip
                                stripRef={this.thumbnailsWrapRef}
                                layout="carousel"
                                groups={this.getVariantGalleryThumbGroups()}
                                currentIndex={this.getCurrentGalleryThumbIndex()}
                                onSelect={this.onGalleryThumbSelect}
                                onThumbLoad={this.onThumbImageLoad}
                                onThumbError={this.onThumbImageError}
                            />
                            </div>
                    </div>
                    <div className="po__right">
                                <div className="po__product-info">
                                    {this.renderHeader(product)}
                                    {Object.keys(this.state.moloItems).length > 1 && this.renderColors()}
                                    {!this.props.orderState.order && this.renderSizes(selectedMoloItem)}
                        </div>
                                <div className="po__order-actions">
                                    {this.renderPrices(product)}
                                    {
                                        (!this.props.orderState.order ||
                                            (!this.hasOrderType() &&
                                                !this.props.orderState.order.orderheader.orderIsFinal)) && (
                                            <button
                                                className="button po__order-actions__cta"
                                                onClick={this.onHandleOpenOrderFlow}
                                            >
                                                Add to order
                                            </button>
                                        )
                                    }
                                    {this.props.orderState.order &&
                                        this.props.orderState.order.orderheader.orderIsFinal && (
                                            <div className="po__order-actions__notice">
                                                <h5>
                                                    It is not possible to add products to an already approved order.
                                                    <br />
                                                    Please create a new order.
                                </h5>
                                                <button
                                                    className="button po__order-actions__cta"
                                                    onClick={this.onHandleOpenOrderFlow}
                                                >
                                                    Create new order
                                                </button>
                            </div>
                                        )}
                    </div>
                </div>
            </div> 
                    </section>
                    {showGrid && (
                        <div
                            className={
                                'po__order-dock' +
                                (this.shouldShowOrderToolbar() ? ' po__order-dock--with-toolbar' : '')
                            }
                        >
                            {this.shouldShowOrderToolbar() && (
                                <div className="po__order-dock__toolbar-rail">
                                    {this.renderOrderToolbarHost()}
                                </div>
                            )}
                            <section className="po__grid-section">
                                <div className="po__grid-shell">
                                    <div className="po__grid-shell__scroll-area">
                                        <div
                                            ref={this.gridFrameRef}
                                            className={this.getGridFrameClassName()}
                                            onScroll={this.handleGridFrameScroll}
                                        >
                                            {this.renderOrderGrid()}
                                        </div>
                                        {this.state.gridHasOverflow && (
                                            <div
                                                className={
                                                    'po__grid-shell__scroll-fade po__grid-shell__scroll-fade--bottom' +
                                                    (this.state.gridScrollAtBottom ? '' : ' is-visible')
                                                }
                                                aria-hidden="true"
                                            />
                                        )}
                                    </div>
                                    <div className="po__grid-shell__action">
            <button
                                            type="button"
                                            className={
                                                'po__grid-shell__confirm' +
                                                (!this.hasPendingChanges()
                                                    ? ' po__grid-shell__confirm--close'
                                                    : '')
                                            }
                                            onClick={this.handleFooterAction}
                                        >
                                            {this.hasPendingChanges()
                                                ? 'Confirm and Add to Order'
                                                : 'Close'}
            </button>
                                    </div>
                                </div>
                            </section>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    imageOverlay = (image: string) => {
        return ReactDOM.createPortal(
            <React.Fragment>
                <div
                    className="image-overlay ignore-clickoutside"
                    role="dialog"
                    aria-modal="true"
                    onClick={() => {
                    this.setState({ imageIsExpanded: false })
                    }}
                >
                    <img
                        src={image}
                        alt="zoom"
                        className="ignore-clickoutside"
                        onClick={() => this.setState({ imageIsExpanded: false })}
                    />
                </div>
            </React.Fragment>, document.getElementById('root') as HTMLElement
        )
    }

    handleToggleMaximize = () => {
        const isMaximized = !this.state.isMaximized;
        persistProductOverlayMaximized(isMaximized);
        this.setState({ isMaximized }, () => {
            this.scheduleGridLayoutMeasure();
        });
    };

    onHideModal = () => {
        this.clearGridScrollNudgeTimeouts();
        this.gridNudgeDone = false;
        this.teardownGridOverflowObserver();
        this.setState({
            moloItems: this.initialMoloItems,
            sizes: this.initialSizes,
            changes: this.initialChanges,
            itemsLoading: false,
            imageDoneLoading: false,
            imageMapLoading: false,
            mainImageLoading: false,
            thumbLoaded: {},
            imageLayoutNonce: 0,
            currentStep: 'product',
            infoOpen: false,
            imageMap: [],
            imageMapCurrentIndex: 0,
            currencyCode: 'EUR',
            isOverflowed: false,
            imageIsExpanded: false,
            initialLoadDone: false,
            moloMaster: null,
            toolbarHostReady: false,
            viewVariantKey: '',
            activeCellPrice: null,
            gridHasOverflow: false,
            gridScrollAtTop: true,
            gridScrollAtBottom: true,
            isMaximized: readProductOverlayMaximized(),
        }, () => {
            this.props.hide()
        })
    }

    renderTakeOverBody = () => (
        <div className="take-over__body b2b-product-overlay-body" style={{ display: 'flex' }}>
            <div
                className="b2b-product-overlay__scroll"
                style={{
                    flex: 1,
                    overflow: 'auto',
                    borderTop: '1px solid rgb(0 0 0 / 6%)',
                    height: '100%',
                }}
            >
                <div
                    className="b2b-product-overlay__inner"
                    style={{ margin: '0 auto', paddingBottom: '16px', paddingTop: '12px' }}
                >
                    {this.renderModalContent()}
                </div>
            </div>
        </div>
    );

    render() {
        if (!this.props.showModal) {
            return null;
        }

        return (
            <Overlay
                frameInset={1}
                frameInsetCss={true}
                takeOverClassName={
                    'take-over--b2b-product' +
                    (this.state.isMaximized ? ' take-over--b2b-product-maximized' : '')
                }
                children={this.renderTakeOverBody()}
                hide={this.onHideModal}
                hideHeader={true}
                isShowing={true}
                isMaximized={this.state.isMaximized}
                onToggleMaximize={this.handleToggleMaximize}
            />
        );
    }
}

const mapStateToProps = (states: RootState, ownProps: OwnProps): StateProps => {
    return {
      productState: states.productStore.productStore,
      orderState: states.order.order,
      userState: states.user.user,
      wishlist: states.wishlist,
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>, ownProps: OwnProps): DispatchProps => {
    return {
        getMoloItem: async (masterId: string, currencyCode: string, pricegroup: string) => {
            await dispatch(getMoloItem(masterId, currencyCode,pricegroup))
            console.log('getMoloItem completed [UI]')
        },
        toggleWishlistItem: async (masterId: string, colorCode: string, isCurrentlyOnList: boolean) => {
            await dispatch(toggleWishlistItem(masterId, colorCode, isCurrentlyOnList))
        },
        fetchWishlistItems: async () => {
            await dispatch(fetchWishlistItems())
        },
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductOverlay))